import React from 'react';
import { Grid, Popover, TAGLink, Accordion, AccordionDetails, AccordionSummary, TAGTypography } from '../../../../'; // import WNResearchSearchField from './WNResearchSearchField'

import { ExpandMore } from '@mui/icons-material';

var WNResearchPopover = function WNResearchPopover(_ref) {
  var anchorElNav = _ref.anchorElNav,
      handleChange = _ref.handleChange,
      handleCloseNavMenu = _ref.handleCloseNavMenu,
      isMenuOpen = _ref.isMenuOpen,
      navigationGroups = _ref.navigationGroups,
      selectedAccordion = _ref.selectedAccordion;
  return React.createElement(Popover, {
    id: "WN-research-appbar",
    anchorEl: anchorElNav,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    marginThreshold: 0,
    open: isMenuOpen,
    onClose: handleCloseNavMenu,
    PaperProps: {
      style: {
        top: '84px',
        width: '100%',
        backgroundColor: 'neutrals.white',
        padding: '35px 16px',
        borderRadius: 0,
        boxShadow: 'none'
      }
    }
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 3,
    justifyContent: "flex-start",
    alignItems: "stretch"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 3
  }, navigationGroups.slice(navigationGroups.length - 1).map(function (group, index) {
    var _group$navigationGrou;

    return React.createElement(Grid, {
      item: true,
      key: "".concat(group.id, "-").concat(index)
    }, React.createElement(TAGLink, {
      key: group.navigationGroupLink.id,
      href: group === null || group === void 0 ? void 0 : group.navigationGroupLink.buttonUrl,
      color: "text.primary",
      variant: "bodyMediumBook",
      sx: {
        padding: '0 16px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch'
      }
    }, (_group$navigationGrou = group.navigationGroupLink) === null || _group$navigationGrou === void 0 ? void 0 : _group$navigationGrou.buttonText));
  }), navigationGroups.slice(0, navigationGroups.length - 1).map(function (group) {
    return React.createElement(Grid, {
      item: true,
      key: group.navigationGroupLink.id
    }, React.createElement(Accordion, {
      key: group.navigationGroupLink.id,
      sx: {
        backgroundColor: 'backgrounds.white',
        boxShadow: 'none'
      },
      onChange: handleChange(group.navigationGroupLink.id),
      expanded: selectedAccordion === group.navigationGroupLink.id
    }, React.createElement(AccordionSummary, {
      sx: {
        '&.MuiAccordionSummary-root': {
          minHeight: 'unset'
        },
        '.MuiAccordionSummary-content': {
          margin: 0,
          '&.Mui-expanded': {
            margin: '0 0 10px 0'
          }
        }
      },
      expandIcon: group.navigationLinksForGroup ? React.createElement(ExpandMore, {
        fontSize: "small",
        sx: {
          color: 'primary'
        }
      }) : null
    }, group.navigationLinksForGroup ? React.createElement(TAGTypography, {
      variant: "bodyMediumBook",
      sx: {
        color: 'text.primary',
        justifyContent: 'flex-start',
        lineHeight: '24px'
      }
    }, group.navigationGroupLink.breadcrumbTitle) : React.createElement(TAGLink, {
      href: group.navigationGroupLink.path,
      variant: "bodyMediumBook",
      color: "text.primary"
    }, group.navigationGroupLink.breadcrumbTitle)), group.navigationLinksForGroup && React.createElement(AccordionDetails, {
      sx: {
        '&.MuiAccordionDetails-root': {
          padding: '15px 20px 8px 30px',
          borderTop: '2px solid',
          borderColor: 'tertiary.dark'
        }
      }
    }, React.createElement(Grid, {
      container: true,
      direction: "column",
      spacing: 3,
      sx: {
        paddingLeft: '5px'
      }
    }, group.navigationLinksForGroup.map(function (navigationItem) {
      return React.createElement(Grid, {
        item: true,
        key: navigationItem.id
      }, React.createElement(TAGLink, {
        href: navigationItem.path,
        color: "text.primary"
      }, navigationItem.breadcrumbTitle));
    })))));
  })))));
};

export default WNResearchPopover;